export default class Loader {
    constructor() {
        this.showLoader = false;
    }

    show() {
        this.showLoader = true;
    }

    hide() {
        this.showLoader = false;
    }

    toggle() {
        this.showLoader = !this.showLoader;
    }

    isShowLoader() {
        return this.showLoader;
    }
}



// WEBPACK FOOTER //
// ./app/common/loader/loader.service.js